import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../../../base.component';
import { SegmentationService } from '../../../../services/segmentation/segmentation.service';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';


@Component({
  selector: 'app-audience',
  templateUrl: './audience.component.html',
  styleUrls: ['./audience.component.css']
})


export class AudienceComponent extends BaseComponent implements OnInit {
  @ViewChild('searchText', { static: true }) searchText: ElementRef;
  totalCount: number = 0;
  audienceObj: any = [];
  ord = 'asc';
  colname = "audience_name";
  limit = 10;
  offset = 0;
  page = 1;
  today: number = Date.now();

  constructor(
    private segmentService: SegmentationService
  ) { super(); }


  ngOnInit() {
    localStorage.removeItem("deleteAudienceId")
    this.getAudience();
    this.logdata();
  }

  ngAfterViewInit() {
    this.searchText.nativeElement.value = '';
    fromEvent(this.searchText.nativeElement, 'keyup')
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => {
          this.offset = 0;
          this.page = 1;
          this.ngxSpinnerService.show();
        }),
        switchMap(data => this.segmentService.getAudience(this.limit, this.offset, this.colname, this.ord, this.searchText.nativeElement.value))
      ).subscribe(data => {
        if (data.status) {
          if (data.data.rows == null) { this.audienceObj = [] }
          else { this.audienceObj = data.data.rows }
          this.totalCount = data.data.total;
        } else {
          this.audienceObj = [];
          this.totalCount = 0;
        }
        this.ngxSpinnerService.hide();
      });
  }

  logdata() {
    let themeLogs = {
      log_type: "Audience Segementation View",
      log_name: "Audience Segementation View",
      log_description: "Audience Segementation View",
      moduleid: 1,
      moduleitemid: 7,
      per_id: 14
    }
    this.logs.addNewLogs(themeLogs).subscribe(data => {
      // console.log(data);

    }, error => {
      // console.log(error);
    });

  }
  getAudience() {
    let searchTerm = this.searchText.nativeElement.value;
    this.offset = (this.page - 1) * this.limit;
    this.ngxSpinnerService.show();
    this.segmentService.getAudience(this.limit, this.offset, this.colname, this.ord, searchTerm).subscribe(data => {
      if (data.status) {
        if (data.data.rows == null) { this.audienceObj = [] }
        else { this.audienceObj = data.data.rows }
        this.totalCount = data.data.total;
        this.ngxSpinnerService.hide();
      } else {
        this.audienceObj = [];
        this.totalCount = 0;
        this.ngxSpinnerService.hide();
      }
      this.ngxSpinnerService.hide();
    }, error => {
      // console.log(error);
      this.ngxSpinnerService.hide();

    });
  }

  sorting(col) {
    this.colname = col
    if (this.ord == 'asc') {
      this.ord = 'desc'
    } else {
      this.ord = 'asc'
    }
    this.getAudience()
  }

  deleteAudience(id) {

    this.confirmationDialogService.confirm('Please confirm', 'Are you sure you want to Delete?', 'Yes', 'No')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.segmentService.deleteAudience(id).subscribe(data => {
            if (data.status) {
              this.page = 1;
              this.getAudience();
              setTimeout(() => {
                this.toastrService.success("Deleted Successfully");
              }, 1000)
            }
            else {
              this.toastrService.error(data.message)
            }
            this.ngxSpinnerService.hide();
          }, error => {
            //  console.log(error);
            this.ngxSpinnerService.hide();
          });
        }
      }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

  editAudience(id) {
    localStorage.setItem("deleteAudienceId", id);
    this.router.navigate(['/corporate/add-audience']);
  }
  updateStatus(event, id) {
    event.preventDefault();
    let obj = this.audienceObj.find(element => {
      // console.log(element.get_master_company_type.company_type_id)
      if (element.audience_id === id) {
        return true;
      }
    });

    this.confirmationDialogService.confirm('Please confirm', 'Are you sure you want to change the status To' + ((obj.isactive) ? ' In Active?' : ' Active?'), 'Ok', 'Cancel')
      .then((confirmed) => {
        if (confirmed) {
          obj.status = !obj.isactive;

          this.segmentService.updateAudience(obj, obj.audience_id).subscribe(data => {
            if (data.status) {
              this.getAudience();
              this.toastrService.success("Status Changed Successfully");
            }
            else {
              this.toastrService.error(data.message)
            }

          });
        }
        // else {
        //   this.master.updateJourney(obj).subscribe(data => {
        //     this.getJourney();
        //   });
        // }
      }).catch(() => {
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      });
  }



}

